module.exports = __webpack_public_path__ + "static/3-dda1c7bcd09a14c0123c1e64d2739f6c.jpeg";